import React from "react";
//#region types
import { BaseFormFieldProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import CheckBox from "../../forms/baseFields/checkBox";
//#endregion

const CheckboxInput: React.FC<BaseFormFieldProps> = (props: BaseFormFieldProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.setValue(e.target.checked);
  };

  return (
    <CheckBox
      checked={!!props.value}
      name={props.name}
      onChange={handleChange}
      onBlur={props.onBlur}
      disabled={props.disabled}
    />
  );
};

export default CheckboxInput;

